export enum Services {
    ATGAuth = '<ATG-AUTH-API>',
    ATGSeller = '<ATG-SELLER-API>',
    ATGSupport = '<ATG-SUPPORT-API>',
    Classic = '<CLASSIC-API>',
    Local = '<LOCAL-API>',
    Proxibid = '<PROXIBID-API>',
    SellerPortal = '<SELLERPORTAL-API>',
    Version1 = '<VERSION-1-API>',
    WavebidV2 = '<WAVEBID-API>',
}
